var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 21.4002L23.5333 12.0002L21.6667 10.1335L14.1333 17.6668L10.3333 13.8668L8.46667 15.7335L14.1333 21.4002ZM6.66667 28.0002C5.93333 28.0002 5.30556 27.739 4.78333 27.2168C4.26111 26.6946 4 26.0668 4 25.3335V6.66683C4 5.9335 4.26111 5.30572 4.78333 4.7835C5.30556 4.26127 5.93333 4.00016 6.66667 4.00016H12.2667C12.5556 3.20016 13.0389 2.55572 13.7167 2.06683C14.3944 1.57794 15.1556 1.3335 16 1.3335C16.8444 1.3335 17.6056 1.57794 18.2833 2.06683C18.9611 2.55572 19.4444 3.20016 19.7333 4.00016H25.3333C26.0667 4.00016 26.6944 4.26127 27.2167 4.7835C27.7389 5.30572 28 5.9335 28 6.66683V25.3335C28 26.0668 27.7389 26.6946 27.2167 27.2168C26.6944 27.739 26.0667 28.0002 25.3333 28.0002H6.66667ZM6.66667 25.3335H25.3333V6.66683H6.66667V25.3335ZM16 5.66683C16.2889 5.66683 16.5278 5.57238 16.7167 5.3835C16.9056 5.19461 17 4.95572 17 4.66683C17 4.37794 16.9056 4.13905 16.7167 3.95016C16.5278 3.76127 16.2889 3.66683 16 3.66683C15.7111 3.66683 15.4722 3.76127 15.2833 3.95016C15.0944 4.13905 15 4.37794 15 4.66683C15 4.95572 15.0944 5.19461 15.2833 5.3835C15.4722 5.57238 15.7111 5.66683 16 5.66683Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/Verification.5a805610dfc8c6acc90b3575b1ac2790.svg";
export { ForwardRef as ReactComponent };